import React, { useState } from 'react';
import styles from './policyCancellations.module.scss';
import DashboardNavbar from '../../../examples/Navbars/DashboardNavbar';
import DashboardLayout from '../../../examples/LayoutContainers/DashboardLayout';
import { useTranslation } from 'react-i18next';
import useFetchPolicyCancellationsData from './useFetchPolicyCancellationsData';
import PolicyCancellationsTable from './policyCancellationsTable/policyCancellationsTable';
import SoftTypography from 'components/SoftTypography';
import SoftBox from '../../../components/SoftBox';
import { useGenerateUuid } from 'shared/utils/useGenerateUuid';
import { emit$, AppEvents } from 'shared/services/app-events';
import SearchField from 'shared/components/SearchField/SearchField';

const PolicyCancellations = () => {
  const { t } = useTranslation();
  const [filter, setFilter] = useState('');
  const { data, fetchData } = useFetchPolicyCancellationsData();

  const tableUuid = useGenerateUuid();

  const handleSearchButtonClick = () => {
    emit$(AppEvents.RESET_TABLE_COUNTER, tableUuid);
    fetchData(filter.trim());
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div
        className={styles.policyCancellations}
        data-testid="policyCancellations"
      >
        <SoftBox sx={{ marginTop: '6rem' }}>
          <SoftTypography
            variant="h2"
            fontWeight="bold"
            sx={{ marginBottom: '0.5rem' }}
          >
            {t('POLICY_CANCELLATIONS.header')}
          </SoftTypography>
          <SoftTypography
            variant="body2"
            color="text"
            sx={{ marginBottom: '2rem', whiteSpace: 'pre-line' }}
          >
            {t('POLICY_CANCELLATIONS.description')}
          </SoftTypography>
        </SoftBox>
        <SearchField
          searchFunc={handleSearchButtonClick}
          searchCriteria={filter}
          onSearchCriteriaChange={(event) => setFilter(event.target.value)}
          inputLabel={t('POLICY_CANCELLATIONS.search')}
          inputPlaceholder={t('POLICY_CANCELLATIONS.searchPlaceholder')}
          buttonText={t('POLICY_CANCELLATIONS.searchButton')}
        />
        <PolicyCancellationsTable tableUuid={tableUuid} data={data} />
      </div>
    </DashboardLayout>
  );
};

PolicyCancellations.propTypes = {};

export default PolicyCancellations;
